import {ACTION_TYPE} from "../../util/Constants";

export const ConfigReducer = (state, action) => {
    switch (action.type) {
        case "GET_CAPABILITIES":
            return {
                ...state,
                capability: action.capability
            };
        case ACTION_TYPE.GET_FEATURES_STATUS:
            return {
                ...state,
                featureStatus: {...state.featureStatus, ...action.featureStatus}
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/global/reducers/ConfigReducer.js